import { render, staticRenderFns } from "./PhonesCard.vue?vue&type=template&id=5293e0c5&scoped=true"
import script from "./PhonesCard.vue?vue&type=script&lang=js"
export * from "./PhonesCard.vue?vue&type=script&lang=js"
import style0 from "./PhonesCard.vue?vue&type=style&index=0&id=5293e0c5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5293e0c5",
  null
  
)

export default component.exports